import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@components/ui';
import AceUpLogo from '@components/ui/icons/AceUpLogo';

const NotFoundPage: React.FC = () => (
  <div className="not-found-page min-h-[calc(100vh-64px)] bg-au-body-updated px-4 py-10">
    <div className="flex min-h-[calc(100vh-64px-80px)] items-center justify-center">
      <div className="flex w-full flex-col items-center gap-6 text-center">
        <AceUpLogo className="h-16 w-[136px]" />

        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-3">
            <h1 className="whitespace-nowrap text-center text-[24px] font-medium leading-8 tracking-[-0.24px] text-warning">
              404. Not found.
            </h1>
            <p className="w-full max-w-[521px] whitespace-pre-wrap text-center text-[16px] font-[370] leading-6 text-au-text-secondary">
              {"The page you're looking for doesn't exist."}
            </p>
          </div>

          <Link to="/">
            <Button
              size="lg"
              className="min-w-[88px] rounded-[50px] border-0 px-7 py-[18px] text-[16px] font-medium leading-5 text-white shadow-none forbidden-page__cta"
            >
              Go to dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
